var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTcfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.99902,
    y: 9.15625,
    width: 6.0025,
    height: 6.0025,
    rx: 2,
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58505 9.74374L5.99756 6.15625",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9989 6.15453C8.99921 4.7227 7.98802 3.49004 6.58375 3.21043C5.17948 2.93081 3.77325 3.68211 3.22507 5.00486C2.67689 6.3276 3.13943 7.85338 4.32983 8.64906C5.52023 9.44475 7.10692 9.28872 8.11954 8.27642",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 9.74374L18.0025 6.15625",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 9.15515C19.4344 9.15546 20.6671 8.14427 20.9467 6.74C21.2263 5.33573 20.475 3.9295 19.1523 3.38132C17.8295 2.83314 16.3038 3.29568 15.5081 4.48608C14.7124 5.67648 14.8684 7.26317 15.8807 8.27579",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.415 14.5742L18.0025 18.1617",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0026 15.1602C19.4344 15.1599 20.6671 16.171 20.9467 17.5753C21.2263 18.9796 20.475 20.3858 19.1523 20.934C17.8295 21.4822 16.3038 21.0196 15.5081 19.8292C14.7124 18.6388 14.8684 17.0521 15.8807 16.0395",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58505 14.5742L5.99756 18.1617",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9989 18.1608C8.99921 19.5927 7.98802 20.8253 6.58375 21.1049C5.17948 21.3845 3.77325 20.6332 3.22507 19.3105C2.67689 17.9877 3.13943 16.462 4.32983 15.6663C5.52023 14.8706 7.10692 15.0266 8.11954 16.0389",
    stroke: "#323232",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTcfd);
export default __webpack_public_path__ + "static/media/tcfd.6a5876e21f7eb0fc692b2adb832626da.svg";
export { ForwardRef as ReactComponent };